import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGemsProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGemsProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pl0">Gemfile:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          gem '{component.name}', '~> {version.version}'
        </div>
      </div>

      <div className="grid__item col-1-1 pt- pl0">Install:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          gem install {component.name} --version {version.version}
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems;
